exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".plugin-wrapper .plugin-blank_space[data-v-64c96e1a]{min-height:5px}", ""]);

// exports
